import React, { Component } from "react"

import contentLoader from "./content-loader-hoc"

import { randomInt, range } from "../../../config/util-functions"
import { getNoOfLines } from './content-loader-utils'

class ContentLoaderTags extends Component {
    constructor(props) {
        super(props)
        let tagLengths = []
        if (props.tags) {
            tagLengths = range(props.tags).map(
                _ =>
                    props.tagLength ||
                    randomInt(props.minTagLength, props.maxTagLength + 1)
            )
        } else {
            const noOfLines = getNoOfLines(props)
            let spaceRemaining = noOfLines * 100
            while (spaceRemaining - props.maxTagLength > 0) {
                const tagLength =
                    props.tagLength ||
                    randomInt(props.minTagLength, props.maxTagLength + 1)
                tagLengths.push(tagLength)
                spaceRemaining -= tagLength
            }
            if (spaceRemaining > props.minTagLength) {
                tagLengths.push(props.minTagLength)
            }
        }
        this.state = {
            tagLengths
        }
    }

    render() {
        const { tagLengths } = this.state
        return (
            <div className="tags">
                {tagLengths.map((length, index) => (
                    <div
                        key={index}
                        className="shadow-tag"
                        style={{ width: `${length}%` }}
                    />
                ))}
            </div>
        )
    }
}

ContentLoaderTags.defaultProps = {
    minTagLength: 15,
    maxTagLength: 45,
    lines: 1
}

export default contentLoader(ContentLoaderTags)
